import _regeneratorRuntime from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { required, type } from '@/commons/utils/Rules';
import { getSelds } from "@/routes/api/resources";
import moment from "moment";
import baseFormFlujo from "@/components/Flujo/Templates/baseFormFlujo";
import { getConfigSimulador, validateMontoAPrestar } from "@/routes/api/views/flujo";
import { getFromLocal } from "@/commons/utils/storage";
import { mapGetters } from "vuex";
export default {
  name: "PzBaseSimulador",
  mixins: [baseFormFlujo],
  data: function data() {
    var _this = this;
    var check_prestamo = function check_prestamo(rule, value, callback) {
      _this.$store.dispatch('loader/up', {
        trigger: _this.$options.name
      });
      validateMontoAPrestar(_this.producto.code_string, _this.form.monto, _this.form.linea_otorgar).then(function (res) {
        if (!res.data.validate) {
          return callback(new Error(_this.$t('rules.validate_monto')));
        } else {
          return callback();
        }
      }).catch(function () {
        return callback(new Error(_this.$t('rules.validate_monto')));
      }).finally(function () {
        _this.$store.dispatch('loader/down', {
          trigger: _this.$options.name
        });
      });
    };
    return {
      reference: 'form',
      hoy: '',
      elOfertaView: 'solicitud',
      monto_label: '',
      fechapago_label: '',
      form: {
        monto: this.producto.min_monto,
        plazo: this.producto.min_cuota,
        cuota_sugerida: '',
        monto_oferta: '',
        trabajadores: 1,
        fecha_vencimiento: '',
        tasa: null,
        emision: '',
        cant_decimales: 2,
        valor_vehiculo: '',
        valor_seguro: '',
        valor_prestamo: '',
        entrega_inicial: '',
        valor_transferencia: '',
        linea_otorgar: '',
        linea_otorgar_porc: '',
        comisiones: '',
        pago_total: '',
        intereses: '',
        fecha_primer_vencimiento: ''
      },
      max_cuota: 1,
      max_monto: 1,
      min_cuota: 1,
      min_monto: 1,
      workers: [],
      mensaje: [],
      validation: {
        monto: [required(''), type({
          field: '',
          type: 'number'
        })],
        plazo: [required(''), type({
          field: '',
          type: 'number'
        })]
      },
      rules_formulario1: {
        valor_vehiculo: [required('')],
        entrega_inicial: [required('')],
        valor_seguro: [required('')],
        valor_transferencia: [required('')],
        valor_prestamo: [{
          validator: check_prestamo,
          trigger: 'blur'
        }],
        linea_otorgar: [{
          validator: check_prestamo,
          trigger: 'blur'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      pickerOptionsEmision: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    emitChange: function emitChange() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$emit('simular', _this2.form);
      });
    },
    handleInput: function handleInput() {
      this.$emit('input', this.form);
    },
    setLabels: function setLabels() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this3.producto.needsDocuments) {
                _this3.monto_label = _this3.$t('forms_flujo.PzSimulator.how_many_discount');
                _this3.fechapago_label = _this3.$t('forms_flujo.PzSimulator.limit_date');
                _this3.getOfertaView('descuentos');
              } else {
                _this3.monto_label = _this3.$t('forms_flujo.PzSimulator.how_many_cash');
                _this3.fechapago_label = _this3.$t('forms_flujo.PzSimulator.first_limit_date');
                _this3.getOfertaView('solicitud');
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getOfertaView: function getOfertaView(tipe) {
      this.elOfertaView = tipe + '-' + this.extraData.ofertaView;
    },
    stablishDate: function stablishDate() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var date;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this4.producto.needsFirstDate) {
                date = moment().add(1, 'W').format("DD-MM-YYYY");
                _this4.hoy = date;
                _this4.form.fecha_vencimiento = date;
                _this4.validation.fecha_vencimiento = [required('')];
                _this4.form.emision = date;
                _this4.validation.emision = [required('')];
                _this4.$emit('pick', new Date(date));
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    stablishSelds: function stablishSelds() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this5.producto.needsSelds) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", getSelds().then(function (res) {
                _this5.$store.dispatch('loader/up', {
                  trigger: _this5.$options.name
                });
                _this5.workers = res.data;
                _this5.validation.trabajadores = [required('')];
              }).catch(function () {
                _this5.workers = [];
              }).finally(function () {
                _this5.$store.dispatch('loader/down', {
                  trigger: _this5.$options.name
                });
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getConfSimulador: function getConfSimulador() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data_client, params;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.$store.dispatch('loader/up', {
                trigger: _this6.$options.name
              });
              data_client = getFromLocal('data_client');
              params = {
                code: _this6.producto.code_string,
                documento: data_client ? data_client['identity'] : null
              };
              _context4.next = 5;
              return getConfigSimulador(params).then(function (res) {
                var data = res.data;
                _this6.min_cuota = data.min_cuota;
                _this6.max_cuota = data.max_cuota;
                _this6.min_monto = data.min_monto;
                _this6.max_monto = data.max_monto;
                _this6.form.monto = data.min_monto;
                _this6.form.plazo = data.min_cuota;
                if (_this6.max_monto <= 0 || _this6.max_monto < _this6.min_monto) {
                  _this6.$store.dispatch('loader/down', {
                    trigger: _this6.$options.name
                  });
                  _this6.$router.push({
                    name: 'Rejected'
                  });
                }
              }).catch(function (error) {
                _this6.$store.dispatch('app/catchErrors', {
                  _this: _this6,
                  error: error
                });
              }).finally(function () {
                _this6.$store.dispatch('loader/down', {
                  trigger: _this6.$options.name
                });
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchData: function fetchData() {
      var _this7 = this;
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      var workers = this.stablishSelds();
      var date = this.stablishDate();
      var labels = this.setLabels();
      var getConfSimulador = this.getConfSimulador();
      return Promise.all([getConfSimulador, workers, labels, date]).then(function () {
        _this7.emitChange();
      }).finally(function () {
        _this7.$store.dispatch('loader/down', {
          trigger: _this7.$options.name
        });
      });
    }
  }
};